var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCircleTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#3CB4E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35355 10.1464C5.15829 9.95118 4.84171 9.95118 4.64645 10.1464C4.45118 10.3417 4.45118 10.6583 4.64645 10.8536L5.35355 10.1464ZM7.5 13L7.14645 13.3536L7.5 13.7071L7.85355 13.3536L7.5 13ZM13.8536 7.35355C14.0488 7.15829 14.0488 6.84171 13.8536 6.64645C13.6583 6.45118 13.3417 6.45118 13.1464 6.64645L13.8536 7.35355ZM4.64645 10.8536L7.14645 13.3536L7.85355 12.6464L5.35355 10.1464L4.64645 10.8536ZM7.85355 13.3536L13.8536 7.35355L13.1464 6.64645L7.14645 12.6464L7.85355 13.3536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircleTick);
export default __webpack_public_path__ + "static/media/blueCircleTick.d24877fdb581db720d18494788c97f7f.svg";
export { ForwardRef as ReactComponent };